<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div class="panel panel-default">
      <div class="panel-body">
        <!-- Row 1: Tax Year, From Group Object Key, To Group Object Key -->
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
            <input type="text" 
                   class="form-control" 
                   id="tax-year" 
                   name="tax-year" 
                   placeholder=""
                   [(ngModel)]="amendedCycle.TAX_YEAR" 
                   readonly>
            @if (amendedCycle.TAX_YEAR_NOT_VALID && !amendedCycle.TAX_YEAR) {
<small class="text-danger">
              Please provide Tax Year
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="from-group-obj-key"><b>From Group Object Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="from-group-obj-key" 
                   name="from-group-obj-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.FROM_GROUP_OBJ_KEY">
            @if (amendedCycle.FROM_GROUP_OBJ_KEY_NOT_VALID && !amendedCycle.FROM_GROUP_OBJ_KEY) {
<small class="text-danger">
              Please provide From Group Object Key
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="to-group-obj-key"><b>To Group Object Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="to-group-obj-key" 
                   name="to-group-obj-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.TO_GROUP_OBJ_KEY">
            @if (amendedCycle.TO_GROUP_OBJ_KEY_NOT_VALID && !amendedCycle.TO_GROUP_OBJ_KEY) {
<small class="text-danger">
              Please provide To Group Object Key
            </small>
}
          </div>
        </div>

        <!-- Row 2: Chart Key, Data Type, Account Key -->
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="chart-key"><b>Chart Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="chart-key" 
                   name="chart-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.CHART_KEY">
            @if (amendedCycle.CHART_KEY_NOT_VALID && !amendedCycle.CHART_KEY) {
<small class="text-danger">
              Please provide Chart Key
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="data-type"><b>Data Type<sup>*</sup>:</b></label>
            <select id="data-type" 
                    class="form-control"
                    name="data-type"
                    [(ngModel)]="amendedCycle.DATA_TYPE">
              <option value="">Select Data Type</option>
              @for (type of dataTypeOptions; track $index) {
<option [value]="type">{{ type }}</option>
}
            </select>
            @if (amendedCycle.DATA_TYPE_NOT_VALID && !amendedCycle.DATA_TYPE) {
<small class="text-danger">
              Please provide Data Type
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="acct-key"><b>Account Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="acct-key" 
                   name="acct-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.ACCT_KEY">
            @if (amendedCycle.ACCT_KEY_NOT_VALID && !amendedCycle.ACCT_KEY) {
<small class="text-danger">
              Please provide Account Key
            </small>
}
          </div>
        </div>

        <!-- Row 3: Combination Key, LE Key, ME Key -->
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="combination-key"><b>Combination Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="combination-key" 
                   name="combination-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.COMBINATION_KEY">
            @if (amendedCycle.COMBINATION_KEY_NOT_VALID && !amendedCycle.COMBINATION_KEY) {
<small class="text-danger">
              Please provide Combination Key
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="le-key"><b>LE Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="le-key" 
                   name="le-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.LE_KEY">
            @if (amendedCycle.LE_KEY_NOT_VALID && !amendedCycle.LE_KEY) {
<small class="text-danger">
              Please provide LE Key
            </small>
}
          </div>

          <div class="form-group col-md-4">
            <label for="me-key"><b>ME Key<sup>*</sup>:</b></label>
            <input type="number" 
                   class="form-control" 
                   id="me-key" 
                   name="me-key"
                   placeholder="" 
                   [(ngModel)]="amendedCycle.ME_KEY">
            @if (amendedCycle.ME_KEY_NOT_VALID && !amendedCycle.ME_KEY) {
<small class="text-danger">
              Please provide ME Key
            </small>
}
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

